import SettingsPage from "pages/SettingsPage";
import React from "react";

const SettingsRoute = () => <SettingsPage />;

export default SettingsRoute;
